<script lang="ts">
  import LogoStar from '$lib/components/images/LogoStar.svelte'

  let { tier } = $props<{ target: HTMLElement; tier: number }>()

  let timeoutId: number | undefined = undefined

  const sparkleDuration = 1000

  let [minPause, maxPause] = $derived.by(() => {
    let min: number, max: number
    switch (tier) {
      case 0:
      case 1:
        min = 3000
        max = 5000
        break
      case 2:
        min = 500
        max = 2500
        break
      default:
        min = 50
        max = 1000
        break
    }

    return [sparkleDuration + min, sparkleDuration + max]
  })

  const nextSparkle = () => Math.random() * (maxPause - minPause) + minPause

  let sparkleElement: HTMLElement | undefined = $state()

  let rotate = $state(false)
  let maxScale = $state(1)

  let position: [number, number] = $state([0, 0])

  $effect(() => {
    const sparkle = async () => {
      window.clearTimeout(timeoutId)
      position = [Math.random(), Math.random()]
      maxScale = Math.random() * 0.7 + 0.3
      rotate = false
      await new Promise((resolve) => setTimeout(resolve, 10))
      rotate = true

      timeoutId = window.setTimeout(sparkle, nextSparkle())
    }

    if (tier > 0) {
      timeoutId = window.setTimeout(sparkle, nextSparkle())
    }

    return () => {
      window.clearTimeout(timeoutId)
    }
  })
</script>

<div
  class="sparkle-wrapper tier-{tier}"
  style:top="{position[0] * 100}%"
  style:left="{position[1] * 100}%"
  style:--_max-scale={maxScale}
>
  <div
    bind:this={sparkleElement}
    class="sparkle"
    class:rotate
    style:--_duration="{sparkleDuration}ms"
  >
    <LogoStar />
  </div>
</div>

<style>
  @keyframes sparkle {
    0% {
      rotate: -80deg;
      scale: 0.1;
      opacity: 0;
    }
    30%,
    70% {
      scale: var(--_max-scale);
      opacity: 1;
    }
    100% {
      rotate: 80deg;
      scale: 0.1;
      opacity: 0;
    }
  }
  .sparkle-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 60%;
    height: 60%;
    pointer-events: none;

    &.tier-0 {
      --_tier-bg: #f1e3d6;
      --_tier-color: #8b6443;
    }
    &.tier-1 {
      --_tier-bg: #eeeeee;
      --_tier-color: #767676;
    }
    &.tier-2 {
      --_tier-bg: #fff9b5;
      --_tier-color: #d28f00;
    }
    &.tier-3 {
      --_tier-bg: #cff6ff;
      --_tier-color: #00c3ef;
    }
  }
  .sparkle {
    display: grid;
    position: relative;
    place-content: center;
    translate: -50% -50%;
    opacity: 0;
    width: 100%;
    height: 100%;
    font-size: 2.5rem;
    :global(path) {
      fill: var(--_tier-bg);
      stroke: var(--_tier-color);
      stroke-width: 6px;
    }
  }
  .rotate {
    animation: sparkle var(--_duration) linear;
    animation-duration: var(--_duration);
  }
</style>
